<template>
  <b-card no-body>
    <b-card-body>
      <detail-roles-and-permissions
        ref="rolesAndPermissions"
        type="new"
        :submitting="submitting"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import detailRolesAndPermissions from '@/views/pages/roles/DetailRole.vue';

export default {
  components: {
    BCard,
    BCardBody,
    detailRolesAndPermissions
  },

  mixins: [helper],

  data() {
    return {
      submitting: false,
      id: '',
      name: '',
      description: '',
      status: '',
      data: {}
    };
  },

  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .createRoles(data)
        .then(response => {
          this.$refs.rolesAndPermissions.resetForm();
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({ name: 'roles' });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
